import Util from '../index';
import _ from 'lodash';

import commonService from '@dap/shared-api/common/commonService';
import costInServiceV2 from '@dap/shared-api/tools/finance/costInServiceV2';
import FBUpdateService from '@dap/shared-api/tools/audience-package/fbUpdateService';
import KuaishouAudienceService from '@dap/shared-api/tools/audience-package/listService';
import financeUploadService from '@dap/shared-api/tools/finance/uploadService';
import creativeLibraryService from '@dap/shared-api/tools/creativeLibraryService';
import AdvertiseToutiaoService from '@dap/shared-api/advertise/toutiaoService';
import AdvertiseToutiao2Service from '@dap/shared-api/advertise-2/toutiao2';
import Advertise2GdtService from '@dap/shared-api/advertise-2/gdtService';
import Advertise2FacebookService from '@dap/shared-api/advertise-2/facebookService';
import Advertise2KuaishouService from '@dap/shared-api/advertise-2/kuaishouService';
import CommonService from '@dap/shared-api/common/commonService';
import ToolsEventService from '@dap/shared-api/tools/eventService';
import asaAudienceService from '@dap/shared-api/tools/audience-package/asaAudienceService';
import tiktokAudienceService from '@dap/shared-api/tools/audience-package/tiktokAudienceService';
import OrienteeringPackagEditService from '@dap/shared-api/tools/orienteering-package/editService';
import materialEffectService from '@dap/shared-api/table-2/material/materialEffectService';
import CrowPackageService from '@dap/shared-api/tools/crowPackageServices';
import AutoRuleService from '@dap/shared-api/tools/autoRuleService';
import srcriptManageService from '@dap/shared-api/creative-center/srcriptManageService';
import scriptProjectService from '@dap/shared-api/creative-center/scriptProjectService';
import dictService from '@dap/shared-api/common/dictService';
import tiktokService from '@dap/shared-api/creative-library/tiktokService';
import gameLifeService from '@dap/shared-api/tools/gameLifeService';
import legalAuditService from '@dap/shared-api/tools/legalAuditService';
import ArtResourceCommService from '@dap/shared-api/art-resource/commService';
import testAnalysisService from '@dap/shared-api/observatory/testAnalysisService';
import ToutiaoService from '@dap/shared-api/tools/audience-package/toutiaoService';

export default {
    configInfo: () =>
        commonService.getConfigInfo().then((resp) => ({
            celebritySpreaderList: resp.data.data.red_museum_ad_spreaders,
            default_celebrity_spreader_id: _.result(
                _.find(resp.data.data.red_museum_ad_spreaders, {
                    is_default: 1,
                }),
                'id'
            ),
            celebrityRegPlaceList: resp.data.data.red_museum_dim_countrys,
            celebrityLanguageList: resp.data.data.red_museum_dim_languages,
            celebrityActiveTypeList: resp.data.data.activity_type,
            mallList: resp.data.data.stores,
            opList: resp.data.data.op_list,
        })),
    baseConfig: commonService.getBaseConfig,

    'tableDict.materialEffect': materialEffectService.getDict,

    'observatoryDict.gameList': () => commonService.getObservatoryDict().then((res) => res.data.data.games),
    // 国家
    'observatoryDict.country': () =>
        testAnalysisService.getDimCountrys({ page: 1, per_page: 500 }).then((res) => res.data.data),

    materialDict: commonService.getMaterialDictData,

    'creativeDict.toutiao': () =>
        creativeLibraryService.getCreativeSelector({
            spreader_id: Util.SPREADER_ID_TOUTIAO,
        }),
    'creativeDict.gdt': () =>
        creativeLibraryService.getCreativeSelector({
            spreader_id: Util.SPREADER_ID_GDT,
        }),
    'creativeDict.kuaishou': () =>
        creativeLibraryService.getCreativeSelector({
            spreader_id: Util.SPREADER_ID_KUAISHOU,
        }),
    'creativeDict.facebook': CommonService.getCreativeFacebookDict,
    'creativeDict.tiktok': () =>
        creativeLibraryService.getCreativeSelector({
            spreader_id: Util.SPREADER_ID_TIKTOK,
        }),
    'creativeDict.tiktok_call_to_actions': () => tiktokService.getCallToAction().then((res) => res.data.data.rows),
    'creativeDict.scriptDict': srcriptManageService.getDict,
    'creativeDict.scriptProject': scriptProjectService.getDict,

    'adDict.toutiao': AdvertiseToutiaoService.getToutiaoDict,
    'adDict.toutiao2': AdvertiseToutiao2Service.getToutiaoDict,

    'adDict.gdt': Advertise2GdtService.getGdtDict,
    'adDict.facebook': Advertise2FacebookService.getFacebookDict,
    'adDict.kuaishou': Advertise2KuaishouService.getKuaishouDict,
    'adDict.tiktok': dictService.getAdTiktokDict,
    'adDict.home': () =>
        CommonService.getAd2Dict().then((resp) => ({
            scopeList: resp.data.data.scope,
            adTrendList: resp.data.data.ad_trend_fields,
            dataTrendList: resp.data.data.data_trend_fields,
            spreaderList: resp.data.data.spreader_fields,
        })),

    'tools.event.warnList': ToolsEventService.getEventWarnDict,
    'tools.event.choose': ToolsEventService.getEventDict,
    'tools.event.analyze': ToolsEventService.getAnalyseDict,

    'tools.crowdPackage': CrowPackageService.getDictInfo,

    'tools.finance.dict': costInServiceV2.getFinanceDict,
    'tools.finance.upload': financeUploadService.getDict,

    'tools.audiencePackage.facebook': FBUpdateService.getFbDictData,
    'tools.audiencePackage.kuaishou': KuaishouAudienceService.getKuaishouDict,
    'tools.audiencePackage.gdt': OrienteeringPackagEditService.getGdtOrientation,
    'tools.audiencePackage.asa': asaAudienceService.getASAAudienceDict,
    'tools.audiencePackage.tiktok': tiktokAudienceService.getTiktokAudienceDict,
    'tools.audiencePackage.toutiao': ToutiaoService.getOrientationDic,

    'tools.legalAudit': () =>
        legalAuditService
            .getDict()
            .then((res) => res.data.data)
            .then((res) => ({
                auditReminderList: res.review_warn,
                emergencyList: res.is_crash,
                vendorList: res.vendor,
                originAuditStatusList: res.origin_review_status,
                auditStatusList: res.review_status,
            })),

    'tools.gameLife.dict': gameLifeService.getLifeCycleDict,

    'tools.autoRule.dict': AutoRuleService.getDictInfo2,

    'tools.countryRegions': CrowPackageService.getCountryRegions,

    'artResource.dict': () =>
        ArtResourceCommService.getDict().then((res) => {
            const typeObj = {
                '1,5,6,7,9': 'Modal',
                2: 'Image',
                '3,4': 'Media',
                8: 'Document',
            };

            const getType = (obj, val) => {
                const key = Object.keys(obj).filter((o) => o.indexOf(val) > -1)[0];
                return obj[key];
            };

            const categroyList = res.data.data.category;
            categroyList.forEach((c) => {
                c.color_icon = `arta-c_category_${c.value}`;
                c.icon = `arta-cate_${c.value}`;
                c.player_type = getType(typeObj, c.value);
            });

            return { ...res.data.data, category: categroyList };
        }),
    'artResource.userInfo': ArtResourceCommService.getUserInfo,
};
